import { css } from "@emotion/react";
import styled from "@emotion/styled";

import IconButton from "../../button/IconButton";

import SelectListOption from "./SelectListOption";

export const Control = styled("div")<{ disabled?: boolean }>`
  border: 1px solid ${({ theme }) => theme.col.gray};
  border-radius: 4px;
  display: flex;
  align-items: flex-start;
  overflow: hidden;
  padding: 4px 3px 4px 8px;
  background-color: white;
  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
    `}

  &:focus {
    outline: 1px solid black;
  }
`;

export const SelectContainer = styled("div")`
  width: 100%;
  position: relative;
`;

export const ItemsInputContainer = styled("div")`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  width: 100%;
`;

export const MenuContainer = styled("div")`
  position: absolute;
  width: 100%;
  z-index: 3;
  margin-top: 3px;
  padding-bottom: 10px;
`;

export const Menu = styled("div")`
  width: 100%;
  border-radius: 4px;
  box-shadow:
    0 0 0 1px hsl(0deg 0% 0% / 10%),
    0 4px 11px hsl(0deg 0% 0% / 10%);
  background-color: ${({ theme }) => theme.col.bg};
`;

export const List = styled("div")<{ small?: boolean }>`
  padding: 3px;
  max-height: ${({ small }) =>
    small
      ? "140px"
      : "300px"}; /* remove this once we use usePopper / portals for this */
  overflow-y: auto;
  --webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
`;

export const Input = styled("input")`
  border: 0;
  height: 20px;
  outline: none;
  flex-grow: 1;
  width: 0; /* to fix default width */
  font-weight: 400;
  font-size: ${({ theme }) => theme.font.sm};
  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      pointer-events: none;
      &:placehoder {
        opacity: 0.5;
      }
    `}
`;

export const DropdownToggleButton = styled(IconButton)`
  padding: 2px 4px 2px 6px;
`;

export const ResetButton = styled(IconButton)`
  padding: 2px 8px;
  width: 26px;
`;

export const VerticalSeparator = styled("div")`
  width: 1px;
  margin: 3px 0;
  background-color: ${({ theme }) => theme.col.grayLight};
  align-self: stretch;
  flex-shrink: 0;
`;

export const SxSelectListOption = styled(SelectListOption)`
  margin-bottom: 2px;
`;
